import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';

import {
  areasApi,
  complaintsApi,
  devicesApi,
  reportsApi,
  reviewsApi,
  usersApi,
} from './queries';
import { rangePickerLocaleReducer, usersReducer } from './slices';

export const store = configureStore({
  reducer: {
    [reviewsApi.reducerPath]: reviewsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [devicesApi.reducerPath]: devicesApi.reducer,
    [complaintsApi.reducerPath]: complaintsApi.reducer,
    [areasApi.reducerPath]: areasApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    rangePickerLocale: rangePickerLocaleReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(reviewsApi.middleware)
      .concat(usersApi.middleware)
      .concat(devicesApi.middleware)
      .concat(complaintsApi.middleware)
      .concat(areasApi.middleware)
      .concat(reportsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
